import CryptoJS from 'crypto-js';

export const hwndjs = (queryString, decrypt = false) => {
  const machO = '00000010000000000000000000000000xxxxxxxx';

  if (decrypt) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        queryString,
        machO
      );

      // Convert WordArray to Uint8Array
      const wordArray = bytes.words;
      const uint8Array = new Uint8Array(bytes.sigBytes);
      for (let i = 0; i < bytes.sigBytes; i++) {
        uint8Array[i] =
          (wordArray[i >>> 2] >>> (24 - (i % 4) * 8)) &
          0xff;
      }

      // Convert Uint8Array to string
      const decoder = new TextDecoder('utf-8');
      const decodedText = decoder.decode(uint8Array);

      return decodedText;
    } catch (error) {
      return null;
    }
  } else {
    return CryptoJS.AES.encrypt(
      queryString,
      machO
    ).toString();
  }
};
